import { QuerySwitch } from 'components/QuerySwitch';
import { ShiftSwapLocationSettingsPageForm } from 'pages/Settings/pages/LocationSettings/ShiftSwapLocationSettingsPageForm';
import {
  LocationRecordDetailDataContext,
  LocationRecordDetailDataProvider,
} from 'pages/Settings/pages/LocationSettings/LocationRecordDetail.data.context';
import { FC } from 'react';

export const ShiftSwapLocationSettingsPage: FC = () => {
  return (
    <LocationRecordDetailDataProvider>
      <QuerySwitch
        context={LocationRecordDetailDataContext}
        component={ShiftSwapLocationSettingsPageForm}
      />
    </LocationRecordDetailDataProvider>
  );
};
